module.exports = __webpack_public_path__ + "static/media/FT-FONDO-WEBSITES.929dfc92.jpg";